module.exports = __webpack_public_path__ + "static/media/icomoon.d0d82fe7.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/icomoon.woff2?hujj0d
// module id = ./src/assets/fonts/icomoon.woff2?hujj0d
// module chunks = 23